export default __webpack_public_path__ + "static/media/assista_horizontal-punchout.b1607d04.svg";